module.exports = __webpack_public_path__ + "img/入库剪影.bf266ff2.jpg";